import Iphone from '../../src/legacy/Iphone.tsx';
export default Iphone;
